import { ITabList } from '@components/common';

export * from './userList';
export * from './components/userListFilters';
export * from './components/userListFilterTag';
export * from './components/userListSearch';
export * from './components/userListCard';

export const UsersTab: ITabList[] = [
	{
		key: 1,
		name: 'Users',
		pathUrl: '/lms/users',
		tabIcon: 'icon-user',
	},
];

export const BDESEUsersTab: ITabList[] = [
	{
		key: 1,
		name: 'All Users',
		pathUrl: '/lms/users',
		tabIcon: 'icon-user',
	},
	{
		key: 2,
		name: 'New Leads',
		pathUrl: '/lms/new-leads',
		tabIcon: 'icon-user',
	},
];
